// @ts-nocheck
import React, { useEffect } from 'react'
import { observer, inject } from 'mobx-react'
import {
  UserOutlined,
  EditOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons'
import {
  ActivityHistoryWrapper,
  ActivityItem,
  ActivityIcon,
  ActivityDetails,
  UserIcon, // Chúng ta đang dùng styled-component cho icon này
  EditIcon, // styled-component cho EditIcon
  ClockIcon, // styled-component cho ClockIcon
  TableWrapper,
  TableCell,
} from './ActivityHistoryStyled' // Import styled-component

// Hàm định dạng processed_date
const formatDate = dateString => {
  const date = new Date(dateString)

  // Lấy giờ, phút, ngày, tháng, năm từ đối tượng Date
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Tháng tính từ 0
  const year = date.getFullYear()

  // Trả về định dạng "HH:mm - DD/MM/YYYY"
  return `${hours}:${minutes} - ${day}/${month}/${year}`
}

const translateUrgencyLevel = urgencyLevel => {
  switch (urgencyLevel) {
    case '001':
      return 'Khẩn'
    case '002':
      return 'Hỏa tốc'
    case '003':
      return 'Hỏa tốc hẹn giờ'
    default:
      return 'Không xác định'
  }
}

const formatPermission = permission => {
  switch (permission) {
    case 'VIEW':
      return 'Phối hợp / Theo dõi'
    case 'PIC':
      return 'Lãnh đạo xử lý'
    case 'COOR':
      return 'Người xử lý'
    default:
      return permission // Trả về giá trị permission gốc nếu không có trong danh sách
  }
}

const formatDataBefore = data => {
  try {
    if (data === null || data === undefined) {
      return 'Không có dữ liệu'
    }

    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    if (typeof data === 'object' && data !== null) {
      let result = ''

      // Xử lý danh sách old_persons
      if (
        data.old_persons &&
        Array.isArray(data.old_persons) &&
        data.old_persons.length > 0
      ) {
        const personList = data.old_persons.map(person => {
          const permissionDescription = formatPermission(person.permission)
          return `• ${permissionDescription}: ${person.nameUppercase}` // Định dạng từng cá nhân
        })

        result += `Người đã thêm:<br>${personList.join('<br>')}`
      }

      // Xử lý ngày tháng (startDate, endDate) nếu có
      if (data.document_dates) {
        const { startDate, endDate } = data.document_dates

        // Lấy giá trị ngày từ dữ liệu, kiểm tra hợp lệ
        const parsedStartDate = startDate
          ? new Date(
              startDate.dateTime.date.year,
              startDate.dateTime.date.month - 1,
              startDate.dateTime.date.day
            )
          : null

        const parsedEndDate = endDate
          ? new Date(
              endDate.dateTime.date.year,
              endDate.dateTime.date.month - 1,
              endDate.dateTime.date.day
            )
          : null

        // Kiểm tra ngày hợp lệ
        const startDateFormatted =
          parsedStartDate && !isNaN(parsedStartDate)
            ? parsedStartDate.toLocaleDateString('vi-VN', {
                timeZone: 'Asia/Ho_Chi_Minh',
              })
            : 'Không có'

        const endDateFormatted =
          parsedEndDate && !isNaN(parsedEndDate)
            ? parsedEndDate.toLocaleDateString('vi-VN', {
                timeZone: 'Asia/Ho_Chi_Minh',
              })
            : 'Không có'

        result += `<br><br>Ngày xử lý văn bản: <br> 
          • Ngày bắt đầu: ${startDateFormatted} <br>• Ngày kết thúc: ${endDateFormatted}`
      }

      // Xử lý trạng thái tài liệu (document_status) nếu có
      if (data.document_status) {
        let documentStatus = data.document_status
        if (documentStatus === 'PENDING') {
          documentStatus = 'Chưa xử lý'
        } else if (documentStatus === 'INPROGRESS') {
          documentStatus = 'Đã bút phê'
        } else if (documentStatus === 'COMPLETE') {
          documentStatus = 'Hoàn thành'
        }

        result += `<br><br>Trạng thái tài liệu: ${documentStatus}`
      }

      // Xử lý remove_persons nếu có
      if (data.remove_persons && typeof data.remove_persons === 'object') {
        let removePersonsData = []

        const {
          bookGroupName,
          bookName,
          documentNumber,
          incomingNumber,
          title,
          outgoingDocumentDate,
          dateIssued,
          signer,
          urgencyLevel,
          attachments,
          authorityIssuedName,
        } = data.remove_persons

        if (bookGroupName) {
          removePersonsData.push(`• Nhóm số văn bản : ${bookGroupName}`)
        }
        if (bookName) {
          removePersonsData.push(`• Số văn bản: ${bookName}`)
        }
        if (documentNumber) {
          removePersonsData.push(`• Số hiệu: ${documentNumber}`)
        }
        if (incomingNumber) {
          removePersonsData.push(`• Số đến: ${incomingNumber}`)
        }
        if (title) {
          removePersonsData.push(`• Trích yếu: ${title}`)
        }
        if (outgoingDocumentDate?.dateTime?.date) {
          const { year, month, day } = outgoingDocumentDate.dateTime.date
          removePersonsData.push(`• Ngày đến: ${year}-${month}-${day}`)
        }
        if (dateIssued?.dateTime?.date) {
          const { year, month, day } = dateIssued.dateTime.date
          removePersonsData.push(`• Ngày văn bản: ${year}-${month}-${day}`)
        }
        if (signer) {
          removePersonsData.push(`• Người ký: ${signer}`)
        }
        if (urgencyLevel) {
          const urgencyDescription = translateUrgencyLevel(urgencyLevel)
          removePersonsData.push(`• Độ khẩn: ${urgencyDescription}`)
        }
        if (attachments) {
          removePersonsData.push(
            `• Tài liệu đính kèm:<br>${attachments
              .map(file => `- ${file}`)
              .join('<br>')}`
          )
        }
        if (authorityIssuedName) {
          removePersonsData.push(`• Cơ quan ban hành: ${authorityIssuedName}`)
        }

        if (removePersonsData.length > 0) {
          result += `<br><br>${removePersonsData.join('<br>')}`
        }
      }

      return result || 'Không có dữ liệu'
    }

    return data
  } catch (e) {
    console.error('Error parsing JSON:', e)
    return 'Dữ liệu không hợp lệ'
  }
}

// Hàm chuyển đổi JSON thành văn xuôi
const formatDataAfter = data => {
  try {
    if (data === null || data === undefined) {
      return 'Không có dữ liệu'
    }

    // Nếu data là chuỗi JSON, phân tích nó
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }

    if (typeof data === 'object' && data !== null) {
      let result = ''
      let hasChange = false // Biến đánh dấu có sự thay đổi

      // Xử lý danh sách add_persons
      if (
        data.add_persons &&
        Array.isArray(data.add_persons) &&
        data.add_persons.length > 0
      ) {
        const addedPersons = data.add_persons
          .map(person => {
            const permissionDescription = formatPermission(person.permission)
            return `<span style="color:blue;">• ${permissionDescription}: ${person.nameUppercase}</span>`
          })
          .join('<br>')
        result += `<span style="color:blue;">Người đã thêm:</span><br>${addedPersons}`
        hasChange = true
      }

      // Xử lý danh sách remove_persons
      if (
        data.remove_persons &&
        Array.isArray(data.remove_persons) &&
        data.remove_persons.length > 0
      ) {
        const removedPersons = data.remove_persons
          .map(person => {
            const permissionDescription = formatPermission(person.permission)
            return `<span style="color:red;">• ${permissionDescription}: ${person.nameUppercase}</span>`
          })
          .join('<br>')
        result +=
          (result.length > 0 ? '<br><br>' : '') +
          `<span style="color:red;">Người đã bỏ:</span><br>${removedPersons}`
        hasChange = true
      }

      // Xử lý ngày tháng (startDate, endDate) với trạng thái "unchanged"
      if (data.document_dates) {
        const { startDate, endDate } = data.document_dates

        const getFormattedDate = dateObj => {
          if (!dateObj) return 'Không có'

          if (dateObj.unchanged === true) return null // Không hiển thị nếu không thay đổi

          if (dateObj.unchanged === false) {
            if (dateObj.value) {
              const { year, month, day } = dateObj.value.dateTime.date
              const date = new Date(year, month - 1, day)
              return !isNaN(date.getTime())
                ? date.toLocaleDateString('vi-VN', {
                    timeZone: 'Asia/Ho_Chi_Minh',
                  })
                : 'Không hợp lệ'
            } else {
              return 'Không rõ'
            }
          }

          return 'Không có'
        }

        const startDateFormatted = getFormattedDate(startDate)
        const endDateFormatted = getFormattedDate(endDate)

        // Chỉ thêm thông tin về ngày khi có sự thay đổi
        if (startDateFormatted || endDateFormatted) {
          result += `<br><br>Ngày xử lý văn bản:<br>`
          if (startDateFormatted)
            result += `• Ngày bắt đầu: ${startDateFormatted}<br>`
          if (endDateFormatted) result += `• Ngày kết thúc: ${endDateFormatted}`
          hasChange = true
        }
      }

      // Xử lý trạng thái tài liệu (document_status) nếu có
      if (data.document_status) {
        let documentStatus = data.document_status
        if (documentStatus === 'PENDING') {
          documentStatus = 'Chưa xử lý'
        } else if (documentStatus === 'INPROGRESS') {
          documentStatus = 'Đã bút phê'
        } else if (documentStatus === 'COMPLETE') {
          documentStatus = 'Hoàn thành'
        }
        result += `<br><br>Trạng thái văn bản: ${documentStatus}`
        hasChange = true
      }

      // Xử lý các trường old_persons hoặc thông tin khác nếu có
      if (data.old_persons && typeof data.old_persons === 'object') {
        const {
          bookGroupName,
          bookName,
          documentNumber,
          incomingNumber,
          title,
          outgoingDocumentDate,
          dateIssued,
          signer,
          urgencyLevel,
          attachmentChanges,
          authorityIssuedName,
        } = data.old_persons

        let oldPersonsData = []

        if (bookGroupName) {
          oldPersonsData.push(`• Nhóm số văn bản : ${bookGroupName}`)
        }
        if (bookName) {
          oldPersonsData.push(`• Số văn bản: ${bookName}`)
        }
        if (documentNumber) {
          oldPersonsData.push(`• Số hiệu: ${documentNumber}`)
        }
        if (incomingNumber) {
          oldPersonsData.push(`• Số đến: ${incomingNumber}`)
        }
        if (title) {
          oldPersonsData.push(`• Trích yếu: ${title}`)
        }
        if (outgoingDocumentDate?.dateTime?.date) {
          const { year, month, day } = outgoingDocumentDate.dateTime.date
          oldPersonsData.push(`• Ngày đến: ${year}-${month}-${day}`)
        }
        if (dateIssued?.dateTime?.date) {
          const { year, month, day } = dateIssued.dateTime.date
          oldPersonsData.push(`• Ngày văn bản: ${year}-${month}-${day}`)
        }
        if (signer) {
          oldPersonsData.push(`• Người ký: ${signer}`)
        }
        if (urgencyLevel) {
          const urgencyDescription = translateUrgencyLevel(urgencyLevel)
          oldPersonsData.push(`• Độ khẩn: ${urgencyDescription}`)
        }
        if (attachmentChanges && attachmentChanges.length > 0) {
          const addedFiles = attachmentChanges.filter(change =>
            change.startsWith('Thêm tệp:')
          )
          const removedFiles = attachmentChanges.filter(change =>
            change.startsWith('Bỏ tệp:')
          )
          let content = '• Tài liệu đính kèm đã sửa:<br>'
          if (addedFiles.length > 0) {
            content += `<span style="color:blue;">- Thêm tệp:<br>${addedFiles
              .map(
                file => `&nbsp;&nbsp;&bull; ${file.replace('Thêm tệp: ', '')}`
              )
              .join('<br>')}</span><br>`
          }
          if (removedFiles.length > 0) {
            content += `<span style="color:red;">- Bỏ tệp:<br>${removedFiles
              .map(file => `&nbsp;&nbsp;&bull; ${file.replace('Bỏ tệp: ', '')}`)
              .join('<br>')}</span>`
          }
          oldPersonsData.push(content)
        } else {
          oldPersonsData.push('• Tài liệu đính kèm: Không có thay đổi')
        }
        if (authorityIssuedName) {
          oldPersonsData.push(`• Cơ quan ban hành: ${authorityIssuedName}`)
        }

        if (oldPersonsData.length > 0) {
          result += `<br><br>${oldPersonsData.join('<br>')}`
          hasChange = true
        }
      }

      // Nếu không có thông tin gì thay đổi và tất cả các trường unchanged = true, trả về 'Không có thay đổi'
      if (!hasChange) {
        return 'Không có thay đổi'
      }

      // Trả về kết quả nếu có thay đổi
      return result || 'Không có thay đổi'
    }

    // Nếu không phải đối tượng, trả về dữ liệu như nó là
    return data
  } catch (e) {
    console.error('Error parsing JSON:', e)
    return 'Dữ liệu không hợp lệ'
  }
}

const capitalizeFirstLetters = str => {
  if (typeof str !== 'string') return '' // Trả về chuỗi rỗng nếu đầu vào không phải là chuỗi
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const ActivityHistory = ({ listHistoryLogStore, documentCode }) => {
  // Lấy các dữ liệu và method từ store
  const { historyLists, getLists, isLoading } = listHistoryLogStore

  useEffect(() => {
    if (documentCode) {
      const respone = getLists(documentCode)
    }
  }, [documentCode])

  const actionMapping = {
    CREATE: 'Tạo mới',
    EDIT_ASSIGNEE: 'Thêm người',
    UPDATE: 'Chỉnh sửa',
  }

  const renderActivityItem = (activity, index) => {
    const userUppercase = activity.user.name_uppercase || ''
    const formattedUserUppercase = capitalizeFirstLetters(userUppercase)
    const formattedDataBefore = formatDataBefore(activity.data_before)
    const formattedDataAfter = formatDataAfter(activity.data_after)

    return (
      <ActivityItem key={index}>
        <ul>
          <li>
            <p>
              <b>Đã sửa</b> lúc {formatDate(activity.processed_date)} bởi{' '}
              <b>{formattedUserUppercase}</b>
            </p>
          </li>
        </ul>
        <TableWrapper>
          <TableCell className="title">Trường dữ liệu</TableCell>
          <TableCell className="title">Trước thay đổi</TableCell>
          <TableCell className="title">Sau thay đổi</TableCell>
          <TableCell>{actionMapping[activity.action] || 'N/A'}</TableCell>
          <TableCell
            dangerouslySetInnerHTML={{ __html: formattedDataBefore || 'N/A' }}
          />
          <TableCell
            dangerouslySetInnerHTML={{ __html: formattedDataAfter || 'N/A' }}
          />
        </TableWrapper>
      </ActivityItem>
    )
  }

  return (
    <ActivityHistoryWrapper>
      {isLoading ? (
        <p>Đang tải...</p> // Hiển thị thông báo khi đang tải dữ liệu
      ) : historyLists?.length === 0 ? (
        <p>Không có lịch sử hoạt động.</p> // Thông báo khi không có dữ liệu
      ) : (
        <div className="activity-list">
          {historyLists
            ?.sort((a, b) => {
              const dateA = new Date(a.processed_date).getTime()
              const dateB = new Date(b.processed_date).getTime()
              return dateB - dateA // Sắp xếp theo thứ tự mới nhất đến cũ nhất
            })
            .map(renderActivityItem)}{' '}
          {/* Hiển thị danh sách lịch sử */}
        </div>
      )}
    </ActivityHistoryWrapper>
  )
}

// Inject store 'listHistoryLogStore' và sử dụng observer để render lại khi store thay đổi
export default inject('listHistoryLogStore')(observer(ActivityHistory))
